export default [
  {
    type: '1',
    title: '中央党校（国家行政学院）网络课程中共党史专题讲座',
    time: 1634552310154
  },
  {
    type: '2',
    title: '《社会主义“有点潮”》第二季《新时代学习大会》',
    time: 1635239891126
  },
  {
    type: '3',
    title: '《马克思靠谱》第二季《马上学习》开播',
    time: 1634552310154
  },
  {
    type: '4',
    title: '【纪念建军91周年微视频】擦亮·军魂',
    time: 1635239891126
  },
  {
    type: '5',
    title: '情境党课：《革命理想高于天》',
    time: 1635239891126
  },
  {
    type: '1',
    title: '《党章》青年说第七集：党组织建设的重要性',
    time: 1634552310154
  }
]